import React, { useState, useMemo } from 'react';
import Map from '@/components/map/Map';
import { zoneColorForOrder } from '@/utils/color-zones';

// let dummyToRenderMine = -1;

const LiveMap = ({
	initLocation,
	positions,
	orders,
	width,
	height,
	minWidth,
	maxWidth,
	onClick,
	forDeliveries,
	shouldAnimateTo,
	traffic,
	// The city whose colour zones paint the order pins — admins only.
	colorZonesCity,
	// Which screen this is, for counting Google's billed map loads.
	page,
}) => {
	const [center, setCenter] = useState({ lat: initLocation.lat, lng: initLocation.lng });
	// const [markers, setMarkers] = useState([]);

	// console.log("initLocation livemap ", initLocation);
	// useEffect(() => {
	//   console.log("positions", positions);

	//   const newMarkers = [];
	//   if (positions) {
	//     const now = new Date().getTime();
	//     Object.entries(positions).forEach(([pKey, pos]) => {
	//       let relativeTime = null;

	//       if (process.env.NODE_ENV === "development") {
	//         if (pos.timestamp) {
	//           const diffMs = now - pos.timestamp;
	//           const minutesPassed = Math.max(0, Math.floor(diffMs / 1000 / 60));
	//           if (minutesPassed) {
	//             if (minutesPassed >= 60) {
	//               const hoursPassed = Math.floor(minutesPassed / 60);
	//               relativeTime = `πριν ${hoursPassed} ${hoursPassed === 1 ? "ώρα" : "ώρες"}`;
	//             } else {
	//               relativeTime = `πριν ${minutesPassed}′`;
	//             }
	//           }
	//         }
	//       }

	//       // console.log(pos?.name, relativeTime);

	//       if (pos?.coords?.latitude) {
	//         newMarkers.push({
	//           id: pKey,
	//           name: pos?.name,
	//           lat: pos.coords.latitude,
	//           lng: pos.coords.longitude,
	//           relativeTime,
	//           type: pos.type,
	//         });
	//       }
	//     });
	//   }
	//   // console.log("dd", newMarkers);

	//   // const included = newMarkers.find((m) => m.id === "2363");
	//   // if (included) {
	//   //   newMarkers.push({
	//   //     id: -100,
	//   //     name: "Ελισάβετ",
	//   //     lat: included.lat + 0.005,
	//   //     lng: included.lng + 0.005,
	//   //   });
	//   // }

	//   if (orders) {
	//     orders.forEach((o) => {
	//       // const lat =
	//       //   o.address?.location?.lat ||
	//       //   o?.address?.location?.geometry?.lat ||
	//       //   o?.address?.location?.geometry?.location?.lat;

	//       // const lng =
	//       //   o.address?.location?.lng ||
	//       //   o?.address?.location?.geometry?.lng ||
	//       //   o?.address?.location?.geometry?.location?.lng;

	//       const lat = o.address?.droppedLocationPin?.latitude || o.address?.l?.lat;

	//       const lng = o.address?.droppedLocationPin?.longitude || o.address?.l?.lng;
	//       // console.log("y ", o.address);
	//       if (lat && lng) {
	//         newMarkers.push({
	//           id: o.id,
	//           name: o.address.s,
	//           lat,
	//           lng,
	//           type: "order",
	//         });
	//       } else {
	//         // console.log("no ", o.address);
	//       }
	//     });
	//   }
	//   setMarkers(newMarkers);
	//   // }
	// }, [positions, orders]);

	const stableMarkers = useMemo(() => {
		// console.log("positions", positions);

		const newMarkers = [];
		if (positions) {
			const now = new Date().getTime();
			Object.entries(positions).forEach(([pKey, pos]) => {
				let relativeTime = null;

				if (process.env.NODE_ENV === 'development') {
					if (pos.timestamp) {
						const diffMs = now - pos.timestamp;
						const minutesPassed = Math.max(0, Math.floor(diffMs / 1000 / 60));
						if (minutesPassed) {
							if (minutesPassed >= 60) {
								const hoursPassed = Math.floor(minutesPassed / 60);
								relativeTime = `πριν ${hoursPassed} ${hoursPassed === 1 ? 'ώρα' : 'ώρες'}`;
							} else {
								relativeTime = `πριν ${minutesPassed}′`;
							}
						}
					}
				}

				// console.log(pos?.name, relativeTime);

				if (pos?.coords?.latitude) {
					newMarkers.push({
						id: pKey,
						name: pos?.name,
						lat: pos.coords.latitude,
						lng: pos.coords.longitude,
						relativeTime,
						type: pos.type,
					});
				}
			});
		}
		// console.log("dd", newMarkers);

		// const included = newMarkers.find((m) => m.id === "2363");
		// if (included) {
		//   newMarkers.push({
		//     id: -100,
		//     name: "Ελισάβετ",
		//     lat: included.lat + 0.005,
		//     lng: included.lng + 0.005,
		//   });
		// }

		if (orders) {
			orders.forEach(o => {
				// const lat =
				//   o.address?.location?.lat ||
				//   o?.address?.location?.geometry?.lat ||
				//   o?.address?.location?.geometry?.location?.lat;

				// const lng =
				//   o.address?.location?.lng ||
				//   o?.address?.location?.geometry?.lng ||
				//   o?.address?.location?.geometry?.location?.lng;

				const lat = o.address?.droppedLocationPin?.latitude || o.address?.l?.lat;

				const lng = o.address?.droppedLocationPin?.longitude || o.address?.l?.lng;
				// console.log("y ", o.address);
				if (lat && lng) {
					newMarkers.push({
						id: o.id,
						name: o.address.s,
						lat,
						lng,
						type: 'order',
						color: zoneColorForOrder(o, colorZonesCity),
					});
				} else {
					// console.log("no ", o.address);
				}
			});
		}
		// setMarkers(newMarkers);
		return newMarkers;
	}, [positions, orders, colorZonesCity]);

	// useEffect(() => {
	//   if (dummyToRenderMine !== dummyToRender) {
	//     dummyToRenderMine = dummyToRender;
	//   }
	// }, [dummyToRender]);

	// const onMapClick = () => {
	//   // console.log('CLICK DERP')
	// };

	// console.log("render map - live", initLocation);

	// console.log(markers.map((m) => m.type));
	return (
		<div
			style={{
				// width: width || 500,
				height: height || 400,
				width: width || '100%',
				// minWidth: "100%",
				minWidth: minWidth || 200,
				// maxWidth,
				maxWidth: maxWidth || undefined,
				// position: "relative",
			}}
		>
			<Map
				// center={[initLocation.lat, initLocation.lng]}
				center={center}
				// lat={40.5168959}
				// lng={21.2676692}
				// name='my title'
				onClick={onClick || undefined}
				defaultZoom={15}
				markers={stableMarkers}
				big={forDeliveries}
				shouldAnimateTo={shouldAnimateTo}
				traffic={traffic}
				page={page}
			/>
		</div>
	);
};

export default LiveMap;
